<template>
  <input
    v-model="stringValue"
    type="number"
    @change="update"
    :required="required"
    :min="min"
    :max="max"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    required: {
      type: Boolean,
      required: false
    },
    min: {
      type: Number,
      required: false
    },
    max: {
      type: Number,
      required: false
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      stringValue: null,
      intValue: 0
    };
  },

  watch: {
    value() {
      this.refresh();
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    refresh() {
      this.intValue = this.value;
      this.stringValue = "" + this.value;
    },

    update() {
      if (this.stringValue != null) {
        this.intValue = parseInt(this.stringValue);
        this.$emit("input", this.intValue);
        this.$emit("change");
      }
    }
  }
};
</script>
